<template>
  <div class="p-2">
    <div v-if="icon_list.length === 0">
      Loading...
    </div>
    <suggestion-drag-list :item-list="icon_list" :clone="dragAddItem" style="display: flex; flex-wrap: wrap; justify-content: center;">
      <div
        class="action-draggable card mr-2 mb-2 text-center p-1"
        v-for="icon in icon_list"
        :key="icon.path"
        style="width: unset">
        <img width="64" :src="icon.icon" class="d-block mx-auto" />
        {{icon.name}}
      </div>
    </suggestion-drag-list>
    <p>
      Icons made by <a href="https://www.freepik.com/" title="Freepik">Freepik</a> from
      <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed by
      <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a>
    </p>
  </div>
</template>

<script>
import SuggestionDragList from '../SuggestionDragList'
import SessionManagementMixin from "@/components/Mixins/SessionManagement"
import SuggestionItemMixin from '@/components/TodayPage/Elements/Suggestions/SuggestionItemMixin.js'

export default {
  mixins: [ SessionManagementMixin, SuggestionItemMixin ],
  props: {},
  data: () => ({
    icon_list: [],
  }),
  mounted() {
    let context = require.context('@/assets/packages/daily-routine-objects-actions/svg', true, /\.svg$/)
    this.icon_list = context.keys().map(path => {
      return {
        icon: context(path),
        path: path,
        name: path.slice(6, -4),
      };
    });
  },
  methods: {
    dragAddItem( item ) {

      let dragItem = { // call "make_task"
        type: "INLINE_TASK",
        title: item.name,
        no_drag: false,
        just_dropped: true,
        config: {
          pack: 'daily-routine-objects-actions',
          icon: item.icon,
          tscColor: 'black',
          title: "Enter title"
        },
        component: "flow-quick-session",
        dragConfig: {
          duration: 3600,
          shiftingEnabled: true,
          placeAtEnd: false
        }
      };
      this.setDragItem(dragItem)
      this.setDragItemType('SESSION')
      return dragItem
    },
  },
  components: {
    SuggestionDragList
  }
};
</script>
